
(function(template){
    define('vue!app/views/vue/e-reg-vue-app/components/shareWith/addGuest',['Vue', 'vue!../../reusableComponents/userForm'],function(Vue, userForm){
        return {
            name:'addGuest',
            template:template,
            components: {
                'user-form': userForm
            },
            data: function(){
                return {
                    showAllFields: false,
                    newUser: this.generateUserModel(),
                    disableSubmitButton: true
                }
            },
            methods: {
                loadMore: function(e) {
                    e.preventDefault();
                    this.showAllFields = !this.showAllFields;
                },
                createGuest: function() {
                    var vm = this;
                    var payloadObj = {
                        payload: this.newUser,
                        cb: function(){
                            vm.$emit('submit');
                        }
                    }
                    this.$store.dispatch('pmsCheckin/createGuestAndAddToShareWith', payloadObj);
                },
                copyAddressFromMainUser: function() {
                    var copiedUser = JSON.parse(JSON.stringify(this.newUser))
                    copiedUser.Address[0] = JSON.parse(JSON.stringify(this.$store.state.pmsCheckin.customerDetails.Address[0]));
                    this.newUser = copiedUser;
                }
            },
            watch: {
                newUser: {
                    deep: true,
                    handler: function(newVal, oldVal) {
                        if((newVal.Name.FirstName || '').length == 0 || (newVal.Name.LastName || '').length == 0) {
                            this.disableSubmitButton = true;
                            return;
                        }

                        this.disableSubmitButton = false;
                    }
                }
            }
        }
    })
})('<div> <h3>{{localization.roomReservation.pmsCheckIn.addGuestHeader}}</h3> <user-form :showAllFields="showAllFields" :minimize="true" @loadMore="loadMore" loadMoreText="Show More Fields" :initialData="newUser" idPrepend="newUser" /> <div class="row-fluid"> <div class="span3"> <button :disabled="disableSubmitButton" class="btn btn-warning yellowButton" @click="createGuest"> {{localization.roomReservation.pmsCheckIn.addGuestsLabel}} </button> </div> <div class="span3" v-if="showAllFields"> <button class="btn yellowButton" @click="copyAddressFromMainUser"> {{localization.roomReservation.pmsCheckIn.copyFromUserLabel}} </button> </div> </div> </div>');
